const pricingConstants = {
  PRICING_REFERRAL: 'g6WDsnRXYSrEAV9',
  PRICING_REFERRAL_14T: 'SPxBeLTDMvGMawc',
  // The $99.99 referral set (PROD-6193), replacing the $89.99 one above and at
  // PRICING_YEARLY_8999_7DAYS_REFERRAL / _25OFF when webYearlyPricing2's arm a
  // won. Named after their plans rather than reusing the bare PRICING_REFERRAL
  // shape, because that name says nothing about which base it sits on — which is
  // what made the last two moves hard to audit. The $89.99 records stay defined:
  // they are what existing referral links were quoted against.
  PRICING_REFERRAL_9999_14T: 'aJYUrXJQY5yJrAv',
  PRICING_REFERRAL_9999_30T: 'j3eku6L19RaElaU',
  PRICING_DEFAULT: 'BU2GRzG2hVFwS5a',
  PRICING_COACHING: 'lRcZaTLavJy0kp1',
  PRICING_COACHING_FULL: 'CKipi0UKvEl9KC8',
  PRICING_COACHING_TRIAL: 'sj9tESOvWFziyu5',
  PRICING_UPSELL_FAMILY: 'T2JaZPfrzNVfJbe',
  PRICING_UPSELL_FAMILY_6: '2GCCpQiAh8kpjdF',
  PRICING_UPSELL_FAMILY_6_7999: 'rX8mQv2LpNk7HsD',
  PRICING_UPSELL_FAMILY_6_8999: 'Vn4YcPd8KwE2qLm',
  PRICING_UPSELL_FAMILY_6_9999: 'aW6qLdF2xTnM9bH',
  PRICING_UPSELL_FAMILY_6_10999: 'eY8bKpZ5nRsG3tV',
  PRICING_UPSELL_FAMILY_6_15999_7999BASE: 'kQ9wTfR3nZmV7bX',
  PRICING_UPSELL_FAMILY_6_15999_8999BASE: 'pL5vHcB8sYdN2gT',
  PRICING_UPSELL_FAMILY_6_15999_9999BASE: 'wR7nKqM4tXbG9fJ',
  PRICING_UPSELL_FAMILY_6_15999_10999BASE: 'zT3bYpV6mHsL8dQ',
  // webFamilyPlanPricing2 (PROD-5890). One record per yearly base again, for the
  // same reason the $159.99 set has four: the add-on is the family price minus
  // the individual price the buyer just paid, so only the derived copy differs.
  // One Stripe price per family price still covers every column.
  PRICING_UPSELL_FAMILY_6_17999_7999BASE: 'lYHvkAKI7l25ghZ',
  PRICING_UPSELL_FAMILY_6_17999_8999BASE: 'MMKCuR7iiDBelyL',
  PRICING_UPSELL_FAMILY_6_17999_9999BASE: 'wH83pCEBeeRF4wa',
  PRICING_UPSELL_FAMILY_6_17999_10999BASE: 'AwjzhXaewgvOffV',
  PRICING_UPSELL_FAMILY_6_19999_7999BASE: 'ddmCC0hEtqKAlaI',
  PRICING_UPSELL_FAMILY_6_19999_8999BASE: 'yYphuQoYafxGsEy',
  PRICING_UPSELL_FAMILY_6_19999_9999BASE: 'n0DNNKWRD9rTZs7',
  PRICING_UPSELL_FAMILY_6_19999_10999BASE: '5VzDSVrxnsiYOcc',
  PRICING_MONTHLY: 'hKT8pdmjBgaVzSV',
  PRICING_YEARLY_6999_7DAYS: 'BU2GRzG2hVFwS5a',
  // The three-SKU picker's own 12-month plan. Deliberately its own entry rather
  // than the shared $89.99 one: it must stay out of
  // EXPERIMENT_REPLACEABLE_YEARLY_IDS so the price experiment cannot swap the
  // price the picker displayed, and it carries the picker's own noTrialFee and
  // shortHeaderUI behaviour.
  PRICING_YEARLY_8999_7DAYS_SKU_EXP: 'uSFwRm3kekN0Z4z',
  PRICING_YEARLY_8999_7DAYS_25OFF: 'FxajxgrGhpAPDaS',
  PRICING_INTRO_OFFER: 'BT3XPJIPhlPfKsn',
  PRICING_YEARLY_5999_7DAYS: '7GGdrvosQGJ6urG',
  PRICING_YEARLY_7999_7DAYS: 'u8K9mPzXwQ1vRtN',
  PRICING_YEARLY_8999_7DAYS: 'jG5vTxNdW2mPqKb',
  PRICING_YEARLY_8999_7DAYS_REFERRAL: 'gzOyKUABMchOfqc',
  PRICING_YEARLY_9999_7DAYS: 'hQ3wRkT8mVdN6zB',
  // The $99.99 twins of the two entries above. Like every referral plan these
  // are deliberately absent from EXPERIMENT_REPLACEABLE_YEARLY_IDS, so the price
  // experiment cannot overwrite a price a referrer already promised.
  PRICING_YEARLY_9999_7DAYS_REFERRAL: 'v7MCCKhtiayiErA',
  PRICING_YEARLY_9999_7DAYS_25OFF: 'mNmCmOU5j7F8WwB',
  PRICING_YEARLY_10999_7DAYS: 'cL9nXpJ4tYsW2fD',
  // auraWebPaywallNoTrialPlans (PROD-4467). One no-trial twin per yearly price
  // key, each reusing its 7-day sibling's Stripe price — trial length lives in
  // this config, not in Stripe — so removing the trial never reprices anyone.
  PRICING_YEARLY_7999_NO_TRIAL: 'Wq7nBvR4kMzD2Fy',
  PRICING_YEARLY_8999_NO_TRIAL: 'Ym2gKdV8qPfZ5Nc',
  PRICING_YEARLY_9999_NO_TRIAL: 'Hs9cLpT6wNbX3Rj',
  PRICING_YEARLY_10999_NO_TRIAL: 'Kd3rZmQ9pXvL7Ts',
  PRICING_MONTHLY_1499_NO_TRIAL: 'Nf4tJwS7hCxB6vY',
  PRICING_MONTHLY_INTRO_7999_30DAYS: '0kE7KnJqkDnw3z1',
  PRICING_MONTHLY_INTRO_8999_30DAYS: 'hgn8Bcd77TTmv29',
  PRICING_MONTHLY_INTRO_9999_30DAYS: 'sK7bZqM3wHtV9xR',
  PRICING_MONTHLY_INTRO_10999_30DAYS: 'gT4vNcP8dRbL5mJ',
  PRICING_UPSELL_FAMILY_6_30DAYS: 'buPiKRFTz8hFD4M',
  PRICING_YEARLY_7999_7DAYS_FOLLOW_UP: 'PyJXr4JTjINBRxZ',
  PRICING_YEARLY_9999_7DAYS_FOLLOW_UP: '6zpfNASgYjEkleg',
  PRICING_YEARLY_10999_7DAYS_FOLLOW_UP: 'mO1JtGmNc94ZMqY',
  PRICING_YEARLY_6999_7DAYS_FOLLOW_UP: 'PslW6nDoVZx9aw4',
  PRICING_SIX_MONTH_4999_STRIPE_OFFER: 'xhgflHXuzVLflie',
  PRICING_SIX_MONTH_4999: 'Xq0N8IWyDnjrrMx',
  PRICING_SIX_MONTH_5999: '6rokoyNTt1QXVlR',
  PRICING_SIX_MONTH_6999: '12fmewEpdxAU0kB',
  PRICING_SIX_MONTH_4499_STRIPE_OFFER: 'AsFlvkrP7WMNBOU',
  PRICING_UPSELL_FAMILY_7499_STRIPE_OFFER: 'PdYBUu5YQT7gDfH',
  PRICING_UPSELL_FAMILY_7999_STRIPE_OFFER: '6vTv8LlzSOQxUn1',
  PRICING_NO_TRIAL_3_SKU_DEFAULT: 'McwjYTcblA8OZbg',
  // The list-price monthly plan. The paywall's "X% off yearly" claim is measured
  // against paying this every month for the same span.
  PRICING_MONTHLY_1499: 'AqQAYk9XyTyw2d0',
  COUNTRY_BASED_PRICING_ISO: ['KR', 'BR', 'IN', 'JP'],
  SKU_WITH_TRIAL_PRICING: [
    {
      id: 'AqQAYk9XyTyw2d0',
      duration: 1,
      mostPopular: false,
    },
    {
      id: 'dknAamYEPA9CCuQ',
      duration: 3,
      mostPopular: true,
    },
    {
      id: 'uSFwRm3kekN0Z4z',
      duration: 12,
      mostPopular: false,
    },
  ],
};

// Keyed by the price keys getWebYearlyPriceKey returns, so the yearly plan, its
// $4.99/30-day intro version and the family upsell always move together. The
// family entry here is the $129.99 plan; the family price test picks between
// this and the $159.99 one via FAMILY_UPSELL_BY_PRICE_KEY below.
pricingConstants.YEARLY_PLANS_BY_PRICE_KEY = {
  // mobileYearlyPricing2's control (PROD-4608). No 6999 row existed because no
  // web arm ever ran at $69.99 — the mobile test holds control at today's price
  // instead of raising it to match web, so the webview needs to express it too.
  // All three plans already exist; nothing new was created for this.
  // The family entry reuses the 8999 base, matching what native already does —
  // it sends every gen-2 arm to premium2FamilyPlan_6_12999_7t_8999base. The
  // family price is $129.99 on every base, so only the recorded base differs.
  6999: {
    yearly: pricingConstants.PRICING_DEFAULT,
    monthlyIntro: pricingConstants.PRICING_INTRO_OFFER,
    familyUpsell: pricingConstants.PRICING_UPSELL_FAMILY_6_8999,
  },
  7999: {
    yearly: pricingConstants.PRICING_YEARLY_7999_7DAYS,
    monthlyIntro: pricingConstants.PRICING_MONTHLY_INTRO_7999_30DAYS,
    familyUpsell: pricingConstants.PRICING_UPSELL_FAMILY_6_7999,
  },
  8999: {
    yearly: pricingConstants.PRICING_YEARLY_8999_7DAYS,
    monthlyIntro: pricingConstants.PRICING_MONTHLY_INTRO_8999_30DAYS,
    familyUpsell: pricingConstants.PRICING_UPSELL_FAMILY_6_8999,
  },
  9999: {
    yearly: pricingConstants.PRICING_YEARLY_9999_7DAYS,
    monthlyIntro: pricingConstants.PRICING_MONTHLY_INTRO_9999_30DAYS,
    familyUpsell: pricingConstants.PRICING_UPSELL_FAMILY_6_9999,
  },
  10999: {
    yearly: pricingConstants.PRICING_YEARLY_10999_7DAYS,
    monthlyIntro: pricingConstants.PRICING_MONTHLY_INTRO_10999_30DAYS,
    familyUpsell: pricingConstants.PRICING_UPSELL_FAMILY_6_10999,
  },
};

// The no-trial arms of auraWebPaywallNoTrialPlans, keyed the same way as
// YEARLY_PLANS_BY_PRICE_KEY above so a twin can never drift from the trial plan
// it mirrors. Covering every key is what lets the experiment run across all of
// webYearlyPricing2's arms without changing the price anyone was quoted.
pricingConstants.NO_TRIAL_YEARLY_BY_PRICE_KEY = {
  7999: pricingConstants.PRICING_YEARLY_7999_NO_TRIAL,
  8999: pricingConstants.PRICING_YEARLY_8999_NO_TRIAL,
  9999: pricingConstants.PRICING_YEARLY_9999_NO_TRIAL,
  10999: pricingConstants.PRICING_YEARLY_10999_NO_TRIAL,
};

// Every plan the no-trial arms own. Used to scope the copy changes and the
// removal of the authorization-hold line to this experiment only, so no
// pre-existing plan's paywall shifts.
pricingConstants.NO_TRIAL_PRICING_IDS = [
  ...Object.values(pricingConstants.NO_TRIAL_YEARLY_BY_PRICE_KEY),
  pricingConstants.PRICING_MONTHLY_1499_NO_TRIAL,
];

pricingConstants.SIX_MONTH_PLANS_BY_PRICE_KEY = {
  // $49.99 twice is $99.98, comfortably above $69.99, so control keeps the
  // existing six-month rather than needing a lowered one.
  6999: pricingConstants.PRICING_SIX_MONTH_4999,
  7999: pricingConstants.PRICING_SIX_MONTH_4999,
  8999: pricingConstants.PRICING_SIX_MONTH_4999,
  9999: pricingConstants.PRICING_SIX_MONTH_5999,
  10999: pricingConstants.PRICING_SIX_MONTH_6999,
};

// The yearly-price experiment replaces the standard yearly plan and nothing
// else. Every other plan a visitor can land on — referral, influencer, promo,
// the close-page follow-up offer, coaching, the three-SKU plans — carries a
// price that was chosen deliberately for them, and overwriting it would take
// away the offer they were promised. Listing what may be replaced, rather than
// what may not, keeps a plan added later safe by default.
pricingConstants.EXPERIMENT_REPLACEABLE_YEARLY_IDS = [
  pricingConstants.PRICING_DEFAULT,
  pricingConstants.PRICING_YEARLY_7999_7DAYS,
  pricingConstants.PRICING_YEARLY_8999_7DAYS,
  pricingConstants.PRICING_YEARLY_9999_7DAYS,
  pricingConstants.PRICING_YEARLY_10999_7DAYS,
];

pricingConstants.FOLLOW_UP_OFFER_BY_YEARLY_ID = {
  [pricingConstants.PRICING_DEFAULT]:
    pricingConstants.PRICING_YEARLY_7999_7DAYS_FOLLOW_UP,
  [pricingConstants.PRICING_YEARLY_7999_7DAYS]:
    pricingConstants.PRICING_YEARLY_7999_7DAYS_FOLLOW_UP,
  [pricingConstants.PRICING_YEARLY_8999_7DAYS]:
    pricingConstants.PRICING_YEARLY_7999_7DAYS_FOLLOW_UP,
  [pricingConstants.PRICING_YEARLY_9999_7DAYS]:
    pricingConstants.PRICING_YEARLY_9999_7DAYS_FOLLOW_UP,
  [pricingConstants.PRICING_YEARLY_10999_7DAYS]:
    pricingConstants.PRICING_YEARLY_10999_7DAYS_FOLLOW_UP,
};

// The family plan price test (PROD-4560) crosses with the yearly price test:
// which family plan a buyer is offered depends both on the family arm and on the
// individual price they just paid, because the add-on is the difference between
// the two. One Stripe price per family price covers every column — only the copy
// derived from the individual price differs.
pricingConstants.FAMILY_UPSELL_BY_PRICE_KEY = {
  12999: {
    6999: pricingConstants.PRICING_UPSELL_FAMILY_6_8999,
    7999: pricingConstants.PRICING_UPSELL_FAMILY_6_7999,
    8999: pricingConstants.PRICING_UPSELL_FAMILY_6_8999,
    9999: pricingConstants.PRICING_UPSELL_FAMILY_6_9999,
    10999: pricingConstants.PRICING_UPSELL_FAMILY_6_10999,
  },
  // mobileYearlyPricing2 (PROD-4608) sells $119.99 / 4 members on every arm — the
  // product mobile already sells — so the family plan is not a variable in that
  // test. One plan for all four arms; the base dimension is unused here because
  // the page derives the "Standard $X" line from the arm, not from the plan.
  11999: {
    6999: pricingConstants.PRICING_UPSELL_FAMILY,
    // Reachable once mobileFamilyPlanPricing (PROD-4562) can select this row: a
    // gen-1 web user resolves priceKey 7999, and without this cell the lookup
    // returned undefined and the upsell page errored instead of charging.
    7999: pricingConstants.PRICING_UPSELL_FAMILY,
    8999: pricingConstants.PRICING_UPSELL_FAMILY,
    9999: pricingConstants.PRICING_UPSELL_FAMILY,
    10999: pricingConstants.PRICING_UPSELL_FAMILY,
  },
  15999: {
    6999: pricingConstants.PRICING_UPSELL_FAMILY_6_15999_8999BASE,
    7999: pricingConstants.PRICING_UPSELL_FAMILY_6_15999_7999BASE,
    8999: pricingConstants.PRICING_UPSELL_FAMILY_6_15999_8999BASE,
    9999: pricingConstants.PRICING_UPSELL_FAMILY_6_15999_9999BASE,
    10999: pricingConstants.PRICING_UPSELL_FAMILY_6_15999_10999BASE,
  },
  // webFamilyPlanPricing2's two new arms (PROD-5890). 6999 reuses the 8999base
  // record exactly as the 15999 row above does — the family price is the same on
  // every base, and native sends every gen-2 yearly arm to the 8999 base too.
  17999: {
    6999: pricingConstants.PRICING_UPSELL_FAMILY_6_17999_8999BASE,
    7999: pricingConstants.PRICING_UPSELL_FAMILY_6_17999_7999BASE,
    8999: pricingConstants.PRICING_UPSELL_FAMILY_6_17999_8999BASE,
    9999: pricingConstants.PRICING_UPSELL_FAMILY_6_17999_9999BASE,
    10999: pricingConstants.PRICING_UPSELL_FAMILY_6_17999_10999BASE,
  },
  19999: {
    6999: pricingConstants.PRICING_UPSELL_FAMILY_6_19999_8999BASE,
    7999: pricingConstants.PRICING_UPSELL_FAMILY_6_19999_7999BASE,
    8999: pricingConstants.PRICING_UPSELL_FAMILY_6_19999_8999BASE,
    9999: pricingConstants.PRICING_UPSELL_FAMILY_6_19999_9999BASE,
    10999: pricingConstants.PRICING_UPSELL_FAMILY_6_19999_10999BASE,
  },
};

module.exports = pricingConstants;
